<template>
  <div class="emailContent">
    <div class="emailPage">
      <h1><img :src="homeLogo"/><span>{{homeTitle}}</span></h1>
      <p class="title">{{ title }}</p>
      <el-divider></el-divider>
      <p class="content">{{ contents }}</p>
      <el-button @click="jump" class="right">{{ $t('HostCommon.backHome') }}</el-button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      type: 0,
      acceptVal: 1
    }
  },
  created () {
    const { collaborateLogId, optionType } = this.$route.query
    this.acceptVal = optionType
    this.controlInvite(optionType, collaborateLogId)
  },
  computed: {
    ...mapState({
      State: state => state,
      homeLogo: state => state.homeLogo,
      Config: (state) => state.config,
      homeTitle: state => state.homeTitle
    }),
    title () {
      if (this.acceptVal == 1) {
        return this.$t('coHost.acceptedRequest')
      } else if (this.acceptVal == 2) {
        return this.$t('coHost.declineRequest')
      } else {
        return this.$t('coHost.RequestExpired')
      }
    },
    contents () {
      if (this.acceptVal == 1) {
        return this.$t('coHost.acceptedCoHostRequestText')
      } else if (this.acceptVal == 2) {
        return this.$t('coHost.declineCoHostRequestText')
      } else {
        return this.$t('coHost.RequestCoHostExpiredText')
      }
    }
  },
  methods: {
    jump () {
      const userLoginId = this.State.userLoginId
      if (userLoginId) {
        this.$router.push({
          name: 'commentator'
        })
      } else {
        window.location.href = `${this.Config.urlInfo.userservice}/?url=${location.protocol}//${location.host}/commentator&serviceName=${this.Config.serverName}`
      }
    },
    // 协作&&co-host
    controlInvite (optionType, collaborateLogId) {
      if (!collaborateLogId || !optionType) return
      const params = {
        collaborateLogId: collaborateLogId,
        optionType
      }
      this.$http
        .post(`/commentator-backend/collaborate/noLogin/updateStatus?collaborateLogId=${params.collaborateLogId}&optionType=${params.optionType}`, params, { errorTips: false })
        .then(res => {
          if (res.data.errorCode == '82203101') {
            this.acceptVal = 3 // 3代表过期
          }
        })
    }
  }
}
</script>
<style scoped lang="less">
.el-divider--horizontal {
  margin: 0 0 16px 0;
}
.emailContent {
  height: 100vh;
  margin-top:-5px;
  background: #fff;
}
.emailPage {
  width: 440px;
  background:#FBFBFB;
  border-radius:8px;
  border:2px solid #F2F2F2;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  padding: 20px 45px;
  h1 {
    text-align: center;
    margin-bottom: 40px;
    img {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
    span {
      font-size:24px;
      color:rgba(51,171,79,1);
      line-height:28px;
      background:linear-gradient(233deg, rgba(180,236,81,1) 0%, rgba(66,147,33,1) 100%), linear-gradient(270deg, rgba(3,161,118,1) 0%, rgba(113,186,42,1) 59%, rgba(208,217,0,1) 100%);
      -webkit-background-clip:text;
      -webkit-text-fill-color:transparent;
      position: relative;
      top: -5px;
    }
  }
  p {
    font-size: 16px;
    color: #555661;
    margin-bottom: 16px;
  }
  .title {
    font-weight: bold;
    font-size: 18px;
    color: #28282E;
  }
  .content {
    color: #28282E;
  }
  .el-button {
    border: 0;
    background:linear-gradient(270deg,rgba(3,161,118,1) 0%,rgba(113,186,42,1) 59%,rgba(208,217,0,1) 100%);
    color: #fff;
    padding: 9px 15px;
    border-radius: 4px;
    margin-top: 54px;
  }
}
</style>
